export default "__VITE_PUBLIC_ASSET__65c8de68__"